import type {PropositionConfig, ContractSchema} from '@myparcel-frontend/proposition';
import {getProposition} from '@myparcel-frontend/proposition';
import {toConfigKey, CarrierId} from '@myparcel-frontend/types';
import useFeatures from '../../composables/useFeatures';
import useAcl from '@/composables/useAcl';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';

/**
 * Add carriers to filter out here based on feature flags this can be done for example like this:
 *
 * if (contract.carrier.id === CarrierId.Example) {
 *   return isFeatureActive('carrierContracts.Example');
 * }
 *
 * place the statement in the filterCustomCarriers or filterMainCarriers function depending on which list you want to filter out the carrier from.
 */
const filterCustomCarriers = (customCarriers: (typeof ContractSchema)[]): (typeof ContractSchema)[] => {
  const {isFeatureActive} = useFeatures();

  return customCarriers.filter((contract) => {
    if (contract.carrier.id === CarrierId.Spring) {
      return isFeatureActive('carrierContracts.spring');
    }

    return true;
  });
};

const filterMainCarriers = (carrierContract: (typeof ContractSchema)[]): (typeof ContractSchema)[] => {
  const {isFeatureActive} = useFeatures();

  return carrierContract.filter((contract) => {
    if (contract.carrier.id === CarrierId.DhlFreight) {
      return isFeatureActive('carrierContracts.dhlFreight');
    }

    return true;
  });
};

export const getPropositionConfig = async (): Promise<PropositionConfig> => {
  const {acl} = useAcl();
  const {environment} = useEnvironmentStore();

  const configKey = toConfigKey(acl.value.platform_id);
  if (!configKey) {
    throw new Error('No config found for hostname. Please check the host mapping.');
  }

  const propositionConfig = await getProposition(configKey, environment.environment);
  propositionConfig.assets.url = environment.assetsUrl;

  propositionConfig.contracts.available = filterMainCarriers(propositionConfig.contracts.available);

  propositionConfig.contracts.availableForCustomCredentials = filterCustomCarriers(
    propositionConfig.contracts.availableForCustomCredentials,
  );

  return propositionConfig;
};
